import React, { useContext, useEffect, useState } from "react";
import { bulkAssignAPI, fetchSalesUsersAPI } from "../../../utils/api/crm";
import { Button , Select} from "../../ui";
import { Context } from "../../../context/Context";
import { useAccess } from "../../../access/hooks/useAccess";

export default function BulkAssignBar({ selectedIds, onDone }) {
  const { lang } = useContext(Context);
  const { can } = useAccess();
  const [users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState("");

  useEffect(() => {
    if (can("crm.assignee.update")) fetchSalesUsers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchSalesUsers = async () => {
    const token = localStorage.getItem("auth-token");
    const res = await fetchSalesUsersAPI(token);
    setUsers(res);
  };
  const userOptions = users.map((u) => ({
    value: u._id,
    label: u.name,
  }));

  const handleAssign = async () => {
    // Assigning is the same decision as editing the assignee (NA-010).
    if (!can("crm.assignee.update")) return;
    if (!selectedUser || selectedIds.length === 0) return;

    const token = localStorage.getItem("auth-token");
    await bulkAssignAPI(token, {
      crmIds: selectedIds,
      assignedUserId: selectedUser,
    });

    onDone();
  };

  return (
    <div className="bulkAssignbar">
      <h4>{lang==='ar'?`تم تحديد ${selectedIds.length}`:`${selectedIds.length} selected`}</h4>
      <Select
  placeholder={lang === "ar" ? "اختر" : "Select"}
  options={userOptions}
  value={userOptions.find((o) => o.value === selectedUser)?.value || ""}
  onChange={(e) => setSelectedUser(e.target.value)}
/>

      <Button
        type="button"
        variant="primary"
        appearance="filled"
        size="sm"
        className="notification-btn"
        onClick={handleAssign}
      >
        {lang === "ar" ? "تعيين" : "Assign"}
      </Button>
    </div>
  );
}
